import React, { useContext } from 'react'
import { observer } from 'mobx-react'
import InputText from '@Components/Fields/InputText'
import CustomToolTip from '@Components/Tooltips/CustomToolTip'
import Button from '@Components/Buttons/Button'
import { StoresContext } from '@App/contexts'
import { useParams } from 'react-router'
import { CreatePasswordSceneChildrenProps } from '@Scenes/UserRegistrationScenes/CreatePasswordScene'
import { PARAM } from '@App/navigation/param'

const CreatePasswordForm = (props: CreatePasswordSceneChildrenProps) => {
    const params = useParams<typeof PARAM>()
    const { createPasswordStore } = useContext(StoresContext)

    const { email, passwordError2, passwordError } = createPasswordStore

    const handlePasswordValue = (value: string, id: string) => {
        createPasswordStore.getValue(value, id)
    }

    const createPassword = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault()
        const activatingCode = params.activatingCode
        if (!activatingCode) {
            return
        }
        props.setLoading(true)
        await createPasswordStore.createPassword(activatingCode)
        props.setLoading(false)
    }

    return (
        <div className="global-container">
            <form className="create-password-form" onSubmit={createPassword}>
                <h3>Set your account password</h3>
                <p>
                    Please set the password associated with <br /> address <strong>{email}</strong>
                </p>
                <span className="line">
                    <InputText
                        mainColor
                        id="password"
                        label="Password"
                        errorMessage={passwordError}
                        onChange={handlePasswordValue}
                        required
                        password
                    />
                    <CustomToolTip
                        type="?"
                        info={
                            'Passwords must contain at least 10 characters with at ' +
                            'least one upper case, one lower case, one number and one' +
                            ' special character.'
                        }
                    />
                </span>
                <InputText
                    mainColor
                    id="password2"
                    label="Re enter password"
                    required
                    errorMessage={passwordError2}
                    onChange={handlePasswordValue}
                    password
                />
                <Button mainColor type="primary" disabled={!createPasswordStore.isPasswordValid || props.loading}>
                    Submit
                </Button>
            </form>
        </div>
    )
}

export default observer(CreatePasswordForm)
